import { render, staticRenderFns } from "./MediacontactProductTypeEdit.vue?vue&type=template&id=ba609d08"
import script from "./MediacontactProductTypeEdit.vue?vue&type=script&lang=js"
export * from "./MediacontactProductTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports